import React, { useContext, useEffect, useState } from 'react'
import { AppContext } from '../../context/app'
import { useNavigate } from 'react-router'
import { raiseToast } from '../../utils/helper'
import { isEmpty } from 'lodash'
import addIcon from '../../assets/add-address.png'

const AddressModal = ({ data, setAddress, onClose }) => {
  const { userObj } = useContext(AppContext)
  const navigate = useNavigate()
  const [addresses, setAddresses] = useState([])

  useEffect(() => {
    if (!isEmpty(userObj?.eccom_address)) {
      setAddresses([...userObj.eccom_address])
    }
  }, [userObj])

  return (
    <div
      style={{ backgroundColor: '#0a0a0a90' }}
      className="fixed inset-0 flex items-center justify-center z-50"
    >
      <div
        className="rounded-[10px] w-11/12 md:w-9/12 lg:w-1/2 xl:w-[900px] p-8"
        style={{ backgroundColor: '#1B242F' }}
      >
        {/* Title */}
        <div className="relative w-full mb-6">
          <p className="text-white font-semibold text-xl">Select Address</p>
          <button
            className="absolute top-0 right-0 xl:text-3xl leading-none font-semibold"
            onClick={onClose}
          >
            <span
              style={{ color: '#fff' }}
              className={` h-6 w-6 text-xl block outline-none focus:outline-none`}
            >
              x
            </span>
          </button>
        </div>

        {/* Address Cards Container */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {addresses
            .slice()
            .sort((a, b) => (b.default ? 1 : 0) - (a.default ? 1 : 0))
            .map((item, index) => (
              <div
                key={index}
                className="rounded-[10px] p-5 flex flex-col "
                style={{
                  backgroundColor: '#1d2a39',
                  width: '300px',
                  minHeight: '275px',
                  border: 'solid 1px #707070',
                }}
              >
                {item.default && (
                  <div>
                    <p className=" text-xs mb-1" style={{ color: '#979797' }}>
                      Default Address
                    </p>
                    <hr
                      className="p-0 mb-1"
                      style={{
                        marginLeft: '-1.2rem',
                        marginRight: '-1.2rem',
                      }}
                    />
                  </div>
                )}
                <div className="flex-1">
                  <p className="text-white font-semibold text-base mb-3 line-clamp-2">
                    {' '}
                    {item.name}
                  </p>
                  <p className="text-sm  mb-2" style={{ color: '#979797' }}>
                    Address : {item.address}
                  </p>
                  <p className="text-sm  mb-2" style={{ color: '#979797' }}>
                    City : {item.city}
                  </p>
                  <p className="text-sm  mb-2" style={{ color: '#979797' }}>
                    State : {item.state}
                  </p>
                  <p className="text-sm  mb-2" style={{ color: '#979797' }}>
                    Zipcode : {item.zipcode}
                  </p>
                  <p className="text-sm  mb-2" style={{ color: '#979797' }}>
                    Phone Number : {item.phone}
                  </p>
                </div>
                <button
                  className="rounded px-4 py-2 text-sm flex items-center justify-center gap-2 cursor-pointer"
                  style={{
                    color: '#e3e2e2',
                    backgroundImage:
                      item.id === data?.id
                        ? 'linear-gradient(95deg, #006400 7%, #006400 97%)'
                        : 'linear-gradient(95deg, #f60 7%, #ff4e00 97%)',
                  }}
                  onClick={() => {
                    setAddress(item)
                    raiseToast('success', 'Address updated successfully')
                    onClose()
                  }}
                  disabled={item.id === data?.id}
                >
                  <span>{item.id === data?.id ? 'Selected' : 'Select'}</span>
                </button>
              </div>
            ))}

          {/* Add New Address Card */}
          <div
            className="rounded-[10px] p-5 flex flex-col items-center justify-center cursor-pointer"
            style={{
              border: 'dashed 1px #707070',
              width: '300px',
              minHeight: '275px',
            }}
            onClick={() => navigate('/manage-address')}
          >
            <img src={addIcon} alt="add" className="w-10 h-10 mb-3" />
            <p className="text-sm  leading-[1.57]" style={{ color: '#979797' }}>
              ADD NEW ADDRESS
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddressModal
